export default __webpack_public_path__ + "static/media/drumline.90b0385f.png";